var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "decision-group pl-4" },
    _vm._l(_vm.criteria, function (criterion, criterionIndex) {
      return _c("div", { key: criterionIndex }, [
        criterion !== null
          ? _c(
              "div",
              [
                _c("decision-criterion", {
                  attrs: { criteriaModel: criterion },
                }),
              ],
              1
            )
          : _vm._e(),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }